import {useEffect} from "react";
import { Button } from "./Button";
import Select from "react-select";

export default function Step1BusinessInfo({
  formData,
  updateFormData,
  businessServices,
  businessType,
  selectedBusinessType,
  selectedBusinessServices,
  setSelectedBusinessType,
  setSelectedBusinessServices,
  onNext
}) {
  const handleChange = e => {
    updateFormData({ [e.target.name]: e.target.value });
  };


  const isValid =
    formData.businessname &&
    formData.businessdescription &&
    formData.contactperson &&
    selectedBusinessType;

  return (
    <div>
      <div className="text-xs uppercase text-gray-500 font-medium mb-4">
        STEP 1 OF 5
      </div>

      <h2 className="text-2xl font-bold mb-1">Tell us about your business</h2>
      <p className="text-gray-500 mb-6">Let's start with the basics</p>

      <div className="space-y-4">
        <div>
          <input
            id="businessname"
            name="businessname"
            value={formData.businessname || ""}
            onChange={handleChange}
            placeholder="Business Name*"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent"
            required
          />
        </div>
        <div>
          <Select
            options={businessType}
            value={selectedBusinessType}
            onChange={setSelectedBusinessType}
            placeholder="Select the type of business you own."
            aria-label="Select the type of business you own."
            classNamePrefix="my-select"
            styles={{
              control: base => ({
                ...base,
                minHeight: "60px",
                height: "60px"
              })
            }}
          />
        </div>
        {businessServices &&
          businessServices.length > 0 && (
            <div>
              <Select
                isMulti
                options={businessServices}
                value={selectedBusinessServices}
                onChange={setSelectedBusinessServices}
                placeholder="Select Services offered by this business."
                autoFocus={true}
                closeMenuOnSelect={false}
                classNamePrefix="my-select"
                styles={{
                  control: base => ({
                    ...base,
                    minHeight: "60px",
                    height: "60px"
                  })
                }}
              />
            </div>
          )}
        <div>
          <textarea
            id="businessdescription"
            name="businessdescription"
            value={formData.businessdescription || ""}
            onChange={handleChange}
            placeholder="Business Description*"
            rows={4}
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent"
            required
          />
        </div>

        <div>
          <input
            id="contactperson"
            name="contactperson"
            value={formData.contactperson || ""}
            onChange={handleChange}
            placeholder="Contact Person Name*"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent"
            required
          />
        </div>
      </div>

      <div className="flex justify-end mt-8">
        <Button
          className={`${!isValid && "bg-gray-400"} px-8`}
          onClick={onNext}
          disabled={!isValid}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
